import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { campaignCapabilitiesQuery } from "../lib/campaignCapabilitiesQuery"

type Props = {
  capabilityId: string
  campaignId: string
}

export function useDeleteCampaignCapabilityOverrideMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ capabilityId, campaignId }: Props) => {
      await axios.delete(`/capabilities/${capabilityId}/campaign-override`, {
        data: { campaignId },
      })
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: campaignCapabilitiesQuery({ campaignId: variables.campaignId }).queryKey,
      })
    },
  })
}
